import * as K from 'common/constants';
import ELEMENT from 'common/element';

import { HELP_ROUTE } from 'components/help/constants';
import Dropdown from 'components/common/Dropdown/Dropdown';
import Link from 'components/common/Link/Link';

const sections = [
  [{ text: 'Support', href: K.LINK.SUPPORT, testId: ELEMENT.navDocsSupport }],
  [
    { text: 'Welcome', href: HELP_ROUTE.HELP_WELCOME, testId: ELEMENT.navDocsWelcome },
    { text: 'Getting Started', href: HELP_ROUTE.HELP_GETTING_STARTED, testId: ELEMENT.navDocsStart },
    { text: 'Agent', href: HELP_ROUTE.AGENT, testId: ELEMENT.navDocsAgent },
  ],
  [
    { text: 'Integrations', href: HELP_ROUTE.HELP_SOLUTIONS, testId: ELEMENT.navDocsIntegrations },
    { text: 'Parsers', href: HELP_ROUTE.HELP_PARSING_LOGS, testId: ELEMENT.navDocsParsers },
  ],
  [
    { text: 'Search', href: HELP_ROUTE.HELP_LOG_OVERVIEW, testId: ELEMENT.navDocsSearch },
    { text: 'PowerQueries', href: HELP_ROUTE.HELP_POWER_QUERIES, testId: ELEMENT.navDocsPowerQueries },
    { text: 'Graphs', href: HELP_ROUTE.HELP_GRAPHS, testId: ELEMENT.navDocsGraphs },
  ],
  [
    { text: 'Dashboards', href: HELP_ROUTE.HELP_DASHBOARDS, testId: ELEMENT.navDocsDashboards },
    { text: 'Monitors', href: HELP_ROUTE.HELP_MONITORS, testId: ELEMENT.navDocsMonitors },
    { text: 'Alerts', href: HELP_ROUTE.HELP_ALERTS, testId: ELEMENT.navDocsAlerts },
    { text: 'Configuration Files', href: HELP_ROUTE.HELP_CONFIG, testId: ELEMENT.navDocsConfiguration },
    { text: K.PRODUCT_NAME + ' API', href: HELP_ROUTE.HELP_API, testId: ELEMENT.navDocsApi },
  ],
  [{ text: 'Release Notes', href: K.LINK.RELEASE_NOTES, testId: ELEMENT.navDocsReleaseNotes }],
];

type NavBarDocsDropdownProps = {
  testId?: ELEMENT;
};

/**
 * Help docs dropdown for the navbar
 *
 * @prop testId            Test id for testing
 */
const NavBarDocsDropdown = ({ testId }: NavBarDocsDropdownProps): JSX.Element => (
  <Dropdown isNav sections={sections} itemAs={Link} openInNewTab testId={testId}>
    Docs
  </Dropdown>
);

export default NavBarDocsDropdown;
